// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"81":"60bc8c48","525":"157d3b9e","731":"60bc8c48"}[chunkId] + ".css";
};